import { env, Environment } from '../utils/environment';

import devConfig from './development.json';
import stagingConfig from './staging.json';
import prodConfig from './production.json';

const configMap = {
  [Environment.DEVELOPMENT]: devConfig,
  [Environment.STAGING]: stagingConfig,
  [Environment.PRODUCTION]: prodConfig,
};

export default configMap[env];
